import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'आमची निवड',
  bestPriceBadge: 'सर्वोत्तम किंमत',
  regulatedNotice: {
    prescriptionOnly: 'केवळ प्रिस्क्रिप्शनवर',
    professionalUse: 'व्यावसायिक वापरासाठी',
    fromVeterinarian: 'आपल्या पशुवैद्यांकडे उपलब्ध',
    fromPharmacist: 'फार्मासिस्टकडे उपलब्ध',
    noOnlinePurchase: 'ऑनलाइन विकले जात नाही',
    professionalSupply: 'व्यावसायिक पुरवठादारांमार्फत विकले जाते',
    whyNoLink: 'आम्ही या उत्पादनाचे पुनरावलोकन करतो, पण त्याची लिंक देत नाही.',
  },
};
